// Curated, AI-verified colorful Apple product photos from Unsplash.
// Each entry was visually verified to depict an actual Apple device.
// We pull a fresh random selection for the Home marquee on each load and
// rotate again every 15 minutes (handled in the Home component).

export const APPLE_IMAGE_POOL = {
  iPhone: [
    { id: "1556656793-08538906a9f8", caption: "iPhone Pro" },
    { id: "1565849904461-04a58ad377e0", caption: "iPhone" },
    { id: "1592899677977-9c10ca588bbd", caption: "iPhone lineup" },
    { id: "1605236453806-6ff36851218e", caption: "iPhone" },
    { id: "1607936854279-55e8a4c64888", caption: "iPhones in palm" },
  ],
  Mac: [
    { id: "1517336714731-489689fd1ca8", caption: "MacBook on desk" },
  ],
  iPad: [
    { id: "1623126908029-58cb08a2b272", caption: "iPad with apps" },
    { id: "1561154464-82e9adf32764", caption: "iPad held" },
  ],
  AirPods: [
    { id: "1572569511254-d8f925fe2cbb", caption: "AirPods Pro" },
  ],
  "Apple Watch": [
    { id: "1631281956016-3cdc1b2fe5fb", caption: "Apple Watch" },
    { id: "1551816230-ef5deaed4a26", caption: "Apple Watch with band" },
  ],
  "Apple TV": [
    { id: "1593359677879-a4bb92f829d1", caption: "Apple TV apps" },
  ],
};

// Stable hero candidates (high-res Apple product compositions)
export const HERO_POOL = [
  "1746005514011-ea00280f3b6e",
  "1592899677977-9c10ca588bbd",
  "1556656793-08538906a9f8",
  "1565849904461-04a58ad377e0",
  "1607936854279-55e8a4c64888",
];

export const unsplashUrl = (id, w = 1400) =>
  `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=${w}&q=80`;

// Returns a deterministic pick for a given (category, seed). The same seed
// returns the same image so server/client renders match within the rotation.
const pick = (arr, seed) => arr[Math.abs(seed) % arr.length];

export const pickHero = (seed) => unsplashUrl(pick(HERO_POOL, seed), 1600);

export const pickTiles = (seed) => {
  return Object.entries(APPLE_IMAGE_POOL).map(([cat, pool], i) => ({
    cat,
    img: unsplashUrl(pick(pool, seed + i * 31).id),
  }));
};
